<template>
    <div class="navbar-container d-flex content align-items-center">

        <!-- Nav Menu Toggler -->
        <ul class="nav navbar-nav d-xl-none">
            <li class="nav-item">
                <b-link
                    class="nav-link"
                    @click="toggleVerticalMenuActive"
                >
                    <feather-icon
                        icon="MenuIcon"
                        size="21"
                    />
                </b-link>
            </li>
        </ul>

        <!-- Left Col -->
        <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
            <b-navbar-nav class="nav">
<!--                <DebugToolbar v-if="$store.state.user.profile.attributes.system"/>-->
            </b-navbar-nav>
        </div>

        <b-navbar-nav class="nav align-items-center ml-auto">
            <ReceivedRequestsFlowSwitcher
                v-if="$can('see', 'received-request-flow-selector') && isReceivedRequestFlowSwitcherVisible"
            />
            <organization-selector class="mr-1" />
            <locale class="mr-1" />
<!--            <dark-Toggler class="d-none d-lg-block"/>-->
<!--            <notification-dropdown class="mr-1" />-->
<!--            <user-dropdown/>-->
            <UserName/>
            <b-link
                class="nav-link text-white font-weight-bolder"
                right
                variant="link"
                @click="logout"
            >
                <feather-icon
                    size="16"
                    icon="LogOutIcon"
                    class="mr-50"
                />
                <span>{{ $t('Component(Navbar):logout') }}</span>
            </b-link>
        </b-navbar-nav>
    </div>
</template>

<script>
import {
    BLink, BNavbarNav,
} from 'bootstrap-vue'
import UserName from "@core/layouts/components/app-navbar/components/UserName.vue";
import ReceivedRequestsFlowSwitcher from "@core/layouts/components/app-navbar/components/ReceivedRequestsFlowSwitcher";
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import OrganizationSelector from './components/OrganizationSelectorVSelect.vue'
import SearchBar from './components/SearchBar.vue'
import DarkToggler from './components/DarkToggler.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import DebugToolbar from "@core/layouts/components/app-navbar/components/DebugToolbar";

export default {
    components: {
        BLink, UserName,

        // Navbar Components
        ReceivedRequestsFlowSwitcher,
        DebugToolbar,
        BNavbarNav,
        Bookmarks,
        Locale,
        SearchBar,
        DarkToggler,
        OrganizationSelector,
        NotificationDropdown,
        UserDropdown,
    },
    props: {
        toggleVerticalMenuActive: {
            type: Function,
            default: () => {
            },
        },
    },
    methods: {
        logout() {
            this.$store.dispatch('logout');

            // Reset ability
            this.$ability.update([{
                action: 'read',
                subject: 'Auth',
            }]);

            // Redirect to login page
            this.$router.push({name: 'auth-login'})
        },
    },
    computed: {
        isReceivedRequestFlowSwitcherVisible() {
            return this.$store.state
                .request.received.receivedRequestFlowSwitcherEnvironments
                .includes(this.$store.getters.env);
        }
    }
}
</script>
